// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  as?: ?React.ElementType,
  $compact?: boolean,
  onClick?: () => void,
  children: React.Node,
}

function ListItem({
  as,
  children,
  onClick,
  $compact,
  ...rest
}: Props): React.Node {
  const Component = as || 'div'

  const StyledListItem = tw(Component)`
    hover:bg-gray-50
    border-b
    border-gray-200
    px-4
    py-4
    flex
    hover:no-underline
    cursor-pointer

    ${(props: Props) => {
      if (props.$compact) {
        return `
          py-3
        `
      }

      return ''
    }}
  `

  return (
    <StyledListItem {...rest} $compact={$compact} onClick={onClick}>
      {children}
    </StyledListItem>
  )
}

export default ListItem
